export default "__VITE_ASSET__DkTKBAb8__"